<template>
  <v-container fluid class="new-week-container">
    <v-flex xs12>
      <!-- 🌐 STICKY LANGUAGE TABS -->
      <v-card class="sticky-language-tabs" elevation="3">
        <div class="sticky-header-content">
          <v-tabs v-model="activeLang" color="primary" class="language-tabs">
            <v-tab
              v-for="lang in availableLanguages"
              :key="lang.code"
              :value="lang.code"
              class="language-tab"
            >
              <div class="d-flex align-center">
                <v-icon class="mr-2" size="small">mdi-translate</v-icon>
                <span class="language-name">{{ lang.name.toUpperCase() }}</span>
                <v-chip
                  :color="getCompletionColor(lang.code)"
                  size="x-small"
                  class="ml-2"
                >
                  {{ getCompletionPercentage(lang.code) }}%
                </v-chip>
              </div>
            </v-tab>
          </v-tabs>

          <!-- Action buttons in sticky header -->
          <div class="sticky-actions">
            <v-btn variant="text" size="small" @click="expandAll" class="mr-2">
              <v-icon class="mr-1">mdi-chevron-down</v-icon>
              {{ $t('weeks.expandAll') }}
            </v-btn>
            <v-btn
              variant="text"
              size="small"
              @click="collaspeAll"
              class="mr-2"
            >
              <v-icon class="mr-1">mdi-chevron-up</v-icon>
              {{ $t('weeks.collapseAll') }}
            </v-btn>
          </div>
        </div>
      </v-card>
      <v-form class="mb-12" ref="addeditweekform">
        <v-expansion-panels v-model="openedPanel" multiple class="pa-0">
          <v-expansion-panel class="pt-8 pb-8 px-10 tj-elevation-1">
            <v-expansion-panel-title>
              <div class="font-weight-bold builder-title mr-3">
                {{ $t('weeks.weekBuilder') }}
              </div>
              <template #actions="{ expanded }">
                <ArrowDown
                  :color="arrowColor"
                  :class="['arrow-icon', { 'rotate-180': expanded }]"
                />
              </template>
            </v-expansion-panel-title>
            <v-expansion-panel-text>
              <v-text-field
                v-model="getLC(activeLang).title"
                :label="
                  activeLang === 'en'
                    ? 'Week Title (EN)'
                    : 'Título da Semana (PT)'
                "
                :placeholder="
                  activeLang === 'en'
                    ? 'Enter Text Here (EN)'
                    : 'Digite o texto aqui (PT)'
                "
                :rules="[rules.required, rules.length(3)]"
                hide-details="auto"
                color="green"
                variant="outlined"
                class="mb-7 mt-4"
                style="min-width: 100%"
              ></v-text-field>
              <v-text-field
                v-model="getLC(activeLang).subtitle"
                :label="
                  activeLang === 'en'
                    ? 'Week Subtitle (EN)'
                    : 'Subtítulo da Semana (PT)'
                "
                :placeholder="
                  activeLang === 'en'
                    ? 'Enter Text Here (EN)'
                    : 'Digite o texto aqui (PT)'
                "
                hide-details="auto"
                color="green"
                variant="outlined"
                class="mb-7"
                style="min-width: 100%"
              ></v-text-field>
            </v-expansion-panel-text>
          </v-expansion-panel>

          <v-expansion-panel
            class="pt-8 pb-8"
            elevation="0"
            style="background: transparent"
          >
            <v-expansion-panel-title class="pa-0">
              <div class="font-weight-bold text-h6">
                {{ $t('weeks.mission') }}
              </div>
              <template #actions="{ expanded }">
                <ArrowDown
                  :color="arrowColor"
                  :class="['arrow-icon', { 'rotate-180': expanded }]"
                />
              </template>
            </v-expansion-panel-title>
            <v-divider class="dashed"></v-divider>
            <v-expansion-panel-text class="sub-panel mt-5">
              <v-expansion-panels
                v-model="openedMissionPanels"
                multiple
                class="pa-0"
              >
                <v-expansion-panel class="pt-8 pb-8 px-10 tj-elevation-1">
                  <v-expansion-panel-title>
                    <div class="font-weight-bold text-h6">
                      INTRODUCTION CONTENT
                    </div>
                    <template #actions="{ expanded }">
                      <ArrowDown
                        :color="arrowColor"
                        :class="['arrow-icon', { 'rotate-180': expanded }]"
                      />
                    </template>
                  </v-expansion-panel-title>
                  <v-expansion-panel-text>
                    <div>
                      Instructional text would go here helping to define what
                      questions a user might have as well as provide info for
                      using the module.
                    </div>
                    <CustomQuill
                      :key="`missionBody-${activeLang}`"
                      v-model="getLC(activeLang).missionBodyContent"
                      class="editor-4 mb-8 mt-8"
                      :placeholder="
                        activeLang === 'en'
                          ? 'Enter Description Here (EN)'
                          : 'Digite a descrição aqui (PT)'
                      "
                    />
                  </v-expansion-panel-text>
                </v-expansion-panel>

                <v-expansion-panel class="pt-8 pb-8 px-10 tj-elevation-1">
                  <v-expansion-panel-title>
                    <div class="font-weight-bold text-h6">STUDY QUESTIONS</div>
                    <template #actions="{ expanded }">
                      <ArrowDown
                        :color="arrowColor"
                        :class="['arrow-icon', { 'rotate-180': expanded }]"
                      />
                    </template>
                  </v-expansion-panel-title>
                  <v-expansion-panel-text>
                    <div>
                      Instructional text would go here helping to define what
                      questions a user might have as well as provide info for
                      using the module.
                    </div>
                    <StudyQuestions
                      :backdoor="backdoor"
                      :currentLang="activeLang"
                      :data="getLC(activeLang)"
                      section="missionStudyQuestions"
                      @allstudyquestions="studyQuestionsChild"
                    />
                  </v-expansion-panel-text>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-expansion-panel-text>
          </v-expansion-panel>

          <v-expansion-panel
            class="pt-8 pb-8"
            elevation="0"
            style="background: transparent"
          >
            <v-expansion-panel-title class="pa-0">
              <div class="font-weight-bold text-h6">
                {{ $t('weeks.supplication') }}
              </div>
              <template #actions="{ expanded }">
                <ArrowDown
                  :color="arrowColor"
                  :class="['arrow-icon', { 'rotate-180': expanded }]"
                />
              </template>
            </v-expansion-panel-title>
            <v-divider class="dashed"></v-divider>
            <v-expansion-panel-text class="sub-panel mt-5">
              <v-expansion-panels
                v-model="openedSupplicationsPanels"
                multiple
                class="pa-0"
              >
                <v-expansion-panel class="pt-8 pb-8 px-10 tj-elevation-1">
                  <v-expansion-panel-title>
                    <div class="font-weight-bold text-h6">
                      VERSES AND QUOTES
                    </div>
                    <template #actions="{ expanded }">
                      <ArrowDown
                        :color="arrowColor"
                        :class="['arrow-icon', { 'rotate-180': expanded }]"
                      />
                    </template>
                  </v-expansion-panel-title>
                  <v-expansion-panel-text>
                    <div>
                      Instructional text would go here helping to define what
                      questions a user might have as well as provide info for
                      using the module.
                    </div>
                    <VersesQuotes
                      :backdoor="backdoor"
                      :currentLang="activeLang"
                      :data="getLC(activeLang)"
                      section="supplicationVerseQuotes"
                      @allversequotes="versesQuotesChild"
                    />
                  </v-expansion-panel-text>
                </v-expansion-panel>

                <v-expansion-panel class="pt-8 pb-8 px-10 tj-elevation-1">
                  <v-expansion-panel-title>
                    <div class="font-weight-bold text-h6">
                      INTRODUCTION CONTENT
                    </div>
                    <template #actions="{ expanded }">
                      <ArrowDown
                        :color="arrowColor"
                        :class="['arrow-icon', { 'rotate-180': expanded }]"
                      />
                    </template>
                  </v-expansion-panel-title>
                  <v-expansion-panel-text>
                    <div>
                      Instructional text would go here helping to define what
                      questions a user might have as well as provide info for
                      using the module.
                    </div>
                    <CustomQuill
                      :key="`supplicationBody-${activeLang}`"
                      v-model="getLC(activeLang).supplicationBodyContent"
                      class="editor-4 mb-8 mt-8"
                      :placeholder="
                        activeLang === 'en'
                          ? 'Enter Description Here (EN)'
                          : 'Digite a descrição aqui (PT)'
                      "
                    />
                  </v-expansion-panel-text>
                </v-expansion-panel>

                <v-expansion-panel class="pt-8 pb-8 px-10 tj-elevation-1">
                  <v-expansion-panel-title>
                    <div class="font-weight-bold text-h6">STUDY QUESTIONS</div>
                    <template #actions="{ expanded }">
                      <ArrowDown
                        :color="arrowColor"
                        :class="['arrow-icon', { 'rotate-180': expanded }]"
                      />
                    </template>
                  </v-expansion-panel-title>
                  <v-expansion-panel-text>
                    <div>
                      Instructional text would go here helping to define what
                      questions a user might have as well as provide info for
                      using the module.
                    </div>
                    <StudyQuestions
                      :backdoor="backdoor"
                      :currentLang="activeLang"
                      :data="getLC(activeLang)"
                      section="supplicationStudyQuestions"
                      @allstudyquestions="studyQuestionsChild"
                    />
                  </v-expansion-panel-text>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-expansion-panel-text>
          </v-expansion-panel>
        </v-expansion-panels>

        <v-progress-linear
          v-if="isAddingWeek"
          :indeterminate="isAddingWeek"
          :active="isAddingWeek"
          color="#592892"
          class="mb-5"
        ></v-progress-linear>
        <div class="text-center">
          <v-btn
            color="rgba(165, 216, 103, 1)"
            class="elevation-0 font-weight-bold mb-14 px-14"
            :loading="isAddingWeek"
            :disabled="isAddingWeek"
            @click="addWeek('draft')"
            >{{ $t('weeks.saveAsDraft') }}
            <template #loader>
              <span>Saving...</span>
              <span class="custom-loader">
                <v-icon>cached</v-icon>
              </span>
            </template>
          </v-btn>
          <v-btn
            color="#592892"
            class="elevation-0 font-weight-bold ml-7 mb-14 px-14"
            :loading="isAddingWeek"
            :disabled="isAddingWeek"
            @click="addWeek('published')"
            >{{ $t('weeks.publish') }}
            <template #loader>
              <span>Saving...</span>
              <span class="custom-loader">
                <v-icon>cached</v-icon>
              </span>
            </template>
          </v-btn>
        </div>
        <v-alert
          v-if="feedback"
          border="start"
          color="#592892"
          class="text-center"
        >
          {{ feedback }}
        </v-alert>
        <v-divider class="dashed"></v-divider>
      </v-form>
    </v-flex>
  </v-container>
</template>

<script>
  import db from '@/firebase/init'
  import { mapGetters } from 'vuex'
  import StudyQuestions from '@/components/utilities/StudyQuestions'
  import VersesQuotes from '@/components/utilities/VersesQuotes'
  import CustomQuill from '@/components/utilities/CustomQuill.vue'
  import ArrowDown from '@/assets/icons/ArrowDown.vue'
  import { useLanguages } from '@/helpers/useLanguages'

  export default {
    name: 'NewWeek',
    props: ['allCategories'],
    components: {
      StudyQuestions,
      VersesQuotes,
      CustomQuill,
      ArrowDown,
    },
    setup() {
      const { enabledLangs, defaultLang } = useLanguages()
      return { enabledLangs, defaultLang }
    },
    data() {
      return {
        feedback: null,
        openedPanel: [0, 1, 2, 3, 4],
        openedMissionPanels: [0, 1],
        openedSupplicationsPanels: [0, 1, 2],
        isAddingWeek: false,
        completionScore: 0,
        backdoor: 0,
        activeLang: this.defaultLang || 'en',
        localizedContent: {
          en: {
            title: '',
            subtitle: '',
            supplicationVerseQuotes: [],
            supplicationStudyQuestions: [],
            supplicationBodyContent: '',
            missionBodyContent: '',
            missionStudyQuestions: [],
          },
        },
        // Legacy fields for backward compatibility
        title: '',
        subtitle: '',
        weekCategory: [],
        newCategory: [],
        supplicationVerseQuotes: [],
        supplicationStudyQuestions: [],
        supplicationBodyContent: '',
        missionBodyContent: '',
        missionStudyQuestions: [],
        week: [],
        rules: {
          length: (len) => (v) =>
            (v || '').length >= len || `min ${len} characters required `,
          required: (v) => !!v || 'This field is required',
        },
      }
    },
    computed: {
      ...mapGetters('UserData', ['isAuthenticated']),
      ...mapGetters('AppData', ['cid']),
      availableLanguages() {
        return this.enabledLangs.map((lang) => ({
          code: lang.code,
          name: lang.label,
        }))
      },
    },
    mounted() {
      // Initialize localizedContent for all enabled languages
      this.enabledLangs.forEach((lang) => {
        if (!this.localizedContent[lang.code]) {
          this.localizedContent[lang.code] = {
            title: '',
            subtitle: '',
            supplicationVerseQuotes: [],
            supplicationStudyQuestions: [],
            supplicationBodyContent: '',
            missionBodyContent: '',
            missionStudyQuestions: [],
          }
        }
      })
    },
    methods: {
      addWeek(status) {
        this.feedback = ''

        if (this.getLC(this.activeLang).title) {
          this.isAddingWeek = true

          // filter out any new categories without IDs
          const updatedWeekCategory = this.weekCategory.filter(
            (item) => item.id !== undefined
          )

          // if there was a new category add it to the collection
          if (this.newCategory.length) {
            for (let index = 0; index < this.newCategory.length; index++) {
              const cat = this.newCategory[index]
              db.collection('categories')
                .add({
                  name: cat,
                })
                .then((docRef) => {
                  // add new categories to the week category array
                  updatedWeekCategory.push({
                    id: docRef.id,
                  })
                })
            }
          }
          // remove the name property from the section category array before adding it to the collection
          updatedWeekCategory.map(function (item) {
            delete item.name
            return item
          })

          // Lets debouce this
          if (this.timeout) clearTimeout(this.timeout)

          this.timeout = setTimeout(() => {
            let churchPin = !this.checkAuthorization(['superAdmin'])
              ? this.cid
              : null

            // Get data from localizedContent for the active language
            const currentContent = this.getLC(this.activeLang)

            let supplicationQues =
              currentContent.supplicationStudyQuestions || []
            let suppVrsQts = currentContent.supplicationVerseQuotes || []
            let missionQues = currentContent.missionStudyQuestions || []

            // This is used for caluclating a completion score
            if (currentContent.title) this.completionScore++
            if (currentContent.subtitle) this.completionScore++
            if (suppVrsQts.length) this.completionScore++
            if (supplicationQues.length) this.completionScore++
            if (currentContent.supplicationBodyContent) this.completionScore++
            if (currentContent.missionBodyContent) this.completionScore++
            if (missionQues.length) this.completionScore++

            let type = this.checkAuthorization(['superAdmin'])
              ? 'public'
              : 'private'
            let verified = 'verified'

            // your action
            db.collection('weeks')
              .add({
                cid: churchPin,
                // Legacy fields for backward compatibility
                title: currentContent.title,
                subtitle: currentContent.subtitle,
                supplicationVerseQuotes: suppVrsQts,
                supplicationStudyQuestions: supplicationQues,
                supplicationBodyContent: currentContent.supplicationBodyContent,
                missionBodyContent: currentContent.missionBodyContent,
                missionStudyQuestions: missionQues,
                completionScore: this.completionScore,
                status: status,
                type: type,
                verified: verified,
                // New localizedContent structure
                localizedContent: this.localizedContent,
              })
              .then(() => {
                // trigger the components to reset
                this.backdoor++

                // this.openUnitsForm = false
                this.$emit('closeWeeksForm', {
                  closeWeeksForm: true,
                  title: currentContent.title,
                })

                this.isAddingWeek = false

                // Reset fields
                this.reset()
              })
          }, 300)
        } else {
          this.feedback = 'You need at least a week title'
        }
      },
      checkAuthorization(permissions) {
        const userRoles = this.$store.getters['UserData/getRoles']
        if (permissions && userRoles) {
          const hasRole = permissions.filter(() =>
            userRoles.some((role) => permissions.includes(role))
          )
          if (hasRole && hasRole.length > 0) return true
        }
        return false
      },
      collaspeAll() {
        this.openedPanel = []
        this.openedMissionPanels = []
        this.openedSupplicationsPanels = []
      },
      expandAll() {
        this.openedPanel = [0, 1, 2, 3, 4]
        this.openedMissionPanels = [0, 1]
        this.openedSupplicationsPanels = [0, 1, 2]
      },
      reset() {
        // Reset localizedContent
        this.localizedContent = {
          en: {
            title: '',
            subtitle: '',
            supplicationVerseQuotes: [],
            supplicationStudyQuestions: [],
            supplicationBodyContent: '',
            missionBodyContent: '',
            missionStudyQuestions: [],
          },
          pt: {
            title: '',
            subtitle: '',
            supplicationVerseQuotes: [],
            supplicationStudyQuestions: [],
            supplicationBodyContent: '',
            missionBodyContent: '',
            missionStudyQuestions: [],
          },
        }
        // Reset legacy fields
        this.title = ''
        this.subtitle = ''
        this.weekCategory = []
        this.supplicationVerseQuotes = []
        this.supplicationStudyQuestions = []
        this.supplicationBodyContent = ''
        this.missionBodyContent = ''
        this.missionStudyQuestions = []
      },
      studyQuestionsChild(value) {
        // update the localizedContent with any Study Questions
        if (value.section == 'supplicationStudyQuestions') {
          if (value.questions.length) {
            this.localizedContent[this.activeLang].supplicationStudyQuestions =
              value.questions
          } else {
            this.localizedContent[this.activeLang].supplicationStudyQuestions =
              []
          }
        }

        if (value.section == 'missionStudyQuestions') {
          if (value.questions.length) {
            this.localizedContent[this.activeLang].missionStudyQuestions =
              value.questions
          } else {
            this.localizedContent[this.activeLang].missionStudyQuestions = []
          }
        }
      },
      versesQuotesChild(value) {
        // update the localizedContent with any Verses/Quotes
        if (value.section == 'supplicationVerseQuotes') {
          if (value.versesquotes.length) {
            this.localizedContent[this.activeLang].supplicationVerseQuotes =
              value.versesquotes
          } else {
            this.localizedContent[this.activeLang].supplicationVerseQuotes = []
          }
        }
      },
      // Language handling methods
      getLC(lang) {
        if (!this.localizedContent[lang]) {
          // Ensure the language exists in localizedContent
          this.localizedContent[lang] = {
            title: '',
            subtitle: '',
            supplicationVerseQuotes: [],
            supplicationStudyQuestions: [],
            supplicationBodyContent: '',
            missionBodyContent: '',
            missionStudyQuestions: [],
          }
        }
        return this.localizedContent[lang]
      },
      getCompletionPercentage(lang) {
        const content = this.getLC(lang)
        let completed = 0
        let total = 7 // Total fields in localizedContent structure

        // Track main text fields (4 fields)
        if (content.title && content.title.trim()) completed++
        if (content.subtitle && content.subtitle.trim()) completed++
        if (content.missionBodyContent && content.missionBodyContent.trim())
          completed++
        if (
          content.supplicationBodyContent &&
          content.supplicationBodyContent.trim()
        )
          completed++

        // Track arrays (3 fields) - require at least one item in each
        if (
          content.supplicationVerseQuotes &&
          Array.isArray(content.supplicationVerseQuotes) &&
          content.supplicationVerseQuotes.length > 0
        )
          completed++
        if (
          content.supplicationStudyQuestions &&
          Array.isArray(content.supplicationStudyQuestions) &&
          content.supplicationStudyQuestions.length > 0
        )
          completed++
        if (
          content.missionStudyQuestions &&
          Array.isArray(content.missionStudyQuestions) &&
          content.missionStudyQuestions.length > 0
        )
          completed++

        return Math.round((completed / total) * 100)
      },
      getCompletionColor(lang) {
        const percentage = this.getCompletionPercentage(lang)
        if (percentage === 100) return 'green'
        if (percentage >= 50) return 'orange'
        return 'grey'
      },
      getLanguageColor(lang) {
        const colors = {
          en: 'blue',
          pt: 'green',
          es: 'red',
          fr: 'purple',
        }
        return colors[lang] || 'grey'
      },
      updateCategories() {
        const allCat = this.allCategories
        const weekCat = this.weekCategory

        // Find values that are in weekCat but not in allCat
        this.newCategory = weekCat.filter(function (obj) {
          return !allCat.some(function (obj2) {
            return obj.name == obj2.name
          })
        })
      },
    },
  }
</script>

<style>
  .sml-editor .ql-editor {
    min-height: 100px;
    max-height: 150px;
  }
  .custom-label {
    transform: scale(0.75);
    display: inline-flex;
  }
  .new-week-container .panel-actions {
    display: flex;
    justify-content: flex-end;
    margin-top: -50px;
    padding-bottom: 30px;
  }
  .new-week-container .panel-actions div:first-child {
    margin-right: 20px;
  }
  .new-week-container .panel-action-link-text {
    margin-left: 7px;
  }

  /* Sticky Language Tabs - Matching Units Design Exactly */
  .sticky-language-tabs {
    position: sticky;
    top: 100px;
    z-index: 10;
    background: white;
    border-radius: 8px;
    margin-bottom: 20px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }

  .sticky-header-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px 20px;
  }

  .sticky-actions {
    display: flex;
    gap: 8px;
  }

  .language-tabs {
    background: transparent;
    flex: 1;
  }

  .language-tabs .v-tab {
    min-width: 120px;
  }

  /* Dark mode support */
  .v-theme--dark .sticky-language-tabs {
    background: #1e1e1e;
  }

  .v-theme--dark .language-tabs .v-tab--active {
    color: #bb86fc !important;
  }

  .v-theme--dark .language-tabs .v-tab--active .v-tab__slider {
    background-color: #bb86fc !important;
  }

  .v-theme--dark .language-tabs .v-icon {
    color: #bb86fc;
  }

  .v-theme--dark .language-tabs .v-tab:not(.v-tab--active) .v-icon {
    color: #757575;
  }

  .v-theme--dark .language-tabs .v-tab:not(.v-tab--active) .language-name {
    color: #757575;
  }
</style>
